import { useState } from 'react';
import { API_BASE } from '../config';

export default function Login({ onLogin }) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading,  setLoading]  = useState(false);
    const [error,    setError]    = useState('');

    async function handleLogin(e) {
        e.preventDefault();
        if (!username || !password) { setError('Enter username and password'); return; }
        setLoading(true); setError('');
        try {
            const res  = await fetch(`${API_BASE}/auth?action=login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username: username.trim(), password })
            });
            const data = await res.json();
            if (res.ok && data.success) {
                localStorage.setItem('sf_user', JSON.stringify(data));
                onLogin(data, password);
            } else {
                setError(data.error || 'Invalid credentials');
            }
        } catch(err) {
            setError('Cannot connect to server. Check if backend is running.');
        } finally { setLoading(false); }
    }

    return (
        <div style={{
            minHeight: '100vh', display: 'flex',
            alignItems: 'center', justifyContent: 'center',
            background: '#F5F0EB'
        }}>
            <div style={{
                background: '#fff', borderRadius: '16px',
                padding: '48px 40px', width: '380px',
                boxShadow: '0 4px 24px rgba(0,0,0,0.1)'
            }}>
                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <img src="/soulflower-logo.png" alt="Soulflower"
                        style={{ width: '180px', objectFit: 'contain' }}
                        onError={e => { e.target.style.display = 'none'; }}
                    />
                    <div style={{ fontSize: '13px', color: '#94A3B8', marginTop: '8px', letterSpacing: '2px', textTransform: 'uppercase' }}>
                        Internal Portal
                    </div>
                </div>

                <form onSubmit={handleLogin}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px' }}>
                            Username
                        </label>
                        <input
                            type="text"
                            autoFocus
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            style={{
                                width: '100%', padding: '12px 14px', boxSizing: 'border-box',
                                border: '1.5px solid #E2E8F0', borderRadius: '8px',
                                fontSize: '15px', outline: 'none', background: '#F8FAFC'
                            }}
                            placeholder="Enter username"
                        />
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <label style={{ display: 'block', fontSize: '12px', fontWeight: 700, color: '#475569', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px' }}>
                            Password
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            style={{
                                width: '100%', padding: '12px 14px', boxSizing: 'border-box',
                                border: '1.5px solid #E2E8F0', borderRadius: '8px',
                                fontSize: '15px', outline: 'none', background: '#F8FAFC'
                            }}
                            placeholder="Enter password"
                            onKeyDown={e => { if(e.key === 'Enter') handleLogin(e); }}
                        />
                    </div>

                    {error && (
                        <div style={{
                            padding: '10px 14px', background: '#FEE2E2', color: '#991B1B',
                            borderRadius: '8px', fontSize: '14px', fontWeight: 600,
                            marginBottom: '16px'
                        }}>
                            {error}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%', padding: '13px',
                            background: loading ? '#94A3B8' : 'linear-gradient(135deg,#1A1A1A,#3D3D3D)',
                            color: '#fff', border: 'none', borderRadius: '8px',
                            fontSize: '15px', fontWeight: 700,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.2)'
                        }}
                    >
                        {loading ? 'Signing in...' : 'Sign In'}
                    </button>
                </form>
            </div>
        </div>
    );
}